import linkUtils from 'src/utils/linkUtils';
import { getLocalStorageItem, setLocalStorageItem } from './localStorage';

const LOCAL_DISMISSED = '__hu__fp_dismissed__';
const LOCAL_UNIQUE_IMPRESSIONS = '__hu__fp_uniqueimpression__';
export const formatFeaturedPosts = (featuredPosts) => {
  return featuredPosts
    .filter(featuredPost => !featuredPost.branch || featuredPost.branch === window.HU_TEST_BRANCH)
    .map(post => ({
      ...post,
      communityLogoImageMedium: post.communityLogoImageMedium
        || linkUtils.generateGroupImageUrl(post.logoImageHash),
    }));
};

export const formatFeaturedPostsForSinglePost = (featuredPosts) => {
  const huFeaturedPost = featuredPosts
    .find(post => post.featuredByCommunityName === 'HealthUnlocked');
  const communityFeaturedPost = featuredPosts
    .find(post => post.featuredByCommunityName !== 'HealthUnlocked');

  return [huFeaturedPost, communityFeaturedPost]
    .filter(x => !!x);
};

export const getDismissedFeaturedPostIds = () => {
  return JSON.parse(getLocalStorageItem(LOCAL_DISMISSED) || '[]');
};

export const combinePostsWithFeaturedPosts = (posts, featuredPosts) => {
  const filteredFeaturedPosts = [...featuredPosts];
  if (filteredFeaturedPosts.length == 0) return posts;

  const insertFeaturedIndices = [1, 4];
  // const communityFeaturedPost = filteredFeaturedPosts
  //   .find(post => post.featuredByCommunityName !== 'HealthUnlocked');

  const combined = [];

  for (let i = 0; i < posts.length; i += 1) {
    if (insertFeaturedIndices.includes(i)) {
      // if (i === 4 && communityFeaturedPost) {
      //   combined.push(communityFeaturedPost);
      //   filteredFeaturedPosts.pop();
      // } else {
      combined.push(filteredFeaturedPosts.shift());
      // }
    }
    combined.push(posts[i]);
  }

  return combined;
};

export const addToDismissList = featuredPostId => {
  const dismissed = JSON.parse(getLocalStorageItem(LOCAL_DISMISSED) || '[]');
  dismissed.push(featuredPostId);
  setLocalStorageItem(LOCAL_DISMISSED, JSON.stringify(dismissed));
};

export const isUniqueImpression = featuredPostId => {
  const uniqueImpressions = JSON.parse(getLocalStorageItem(LOCAL_UNIQUE_IMPRESSIONS) || '[]');
  return uniqueImpressions.indexOf(featuredPostId) === -1;
};

export const addToUniqueImpressionsList = featuredPostId => {
  const uniqueImpressions = JSON.parse(getLocalStorageItem(LOCAL_UNIQUE_IMPRESSIONS) || '[]');
  uniqueImpressions.push(featuredPostId);
  setLocalStorageItem(LOCAL_UNIQUE_IMPRESSIONS, JSON.stringify(uniqueImpressions));
};



// WEBPACK FOOTER //
// ./src/utils/featuredPosts.js